export type VehicleModelType = 'LEVE' | 'SEMI_PESADO' | 'EXTRA_PESADO' | 'ELETRICO';

export const VEHICLE_MODEL_TYPE_LABEL: Record<VehicleModelType, string> = {
  LEVE: 'Leve',
  SEMI_PESADO: 'Semipesado',
  EXTRA_PESADO: 'Extrapesado',
  ELETRICO: 'Elétrico',
};

export const VEHICLE_MODEL_TYPE_LABEL_ID: Record<VehicleModelType, string> = {
  LEVE: 'intl-msg:shared.occurrence.vehicleModelType.light',
  SEMI_PESADO: 'intl-msg:shared.occurrence.vehicleModelType.semiHeavy',
  EXTRA_PESADO: 'intl-msg:shared.occurrence.vehicleModelType.extraHeavy',
  ELETRICO: 'intl-msg:shared.occurrence.vehicleModelType.electric',
};

export const VEHICLE_MODEL_TYPE_ORDER: VehicleModelType[] = ['LEVE', 'SEMI_PESADO', 'EXTRA_PESADO', 'ELETRICO'];

export const vehicleModelTypeByModelCode: Record<string, VehicleModelType> = {
  "231BE4": "LEVE",
  "231CE4": "LEVE",
  "231DE4": "LEVE",
  "232AE4": "LEVE",
  "232BE4": "LEVE",
  "232CE4": "LEVE",
  "232D62": "LEVE",
  "232DE4": "LEVE",
  "233AE4": "LEVE",
  "233BE4": "LEVE",
  "233CE4": "LEVE",
  "233DE4": "LEVE",
  "234AE4": "LEVE",
  "234BE4": "LEVE",
  "234CE4": "LEVE",
  "234DE4": "LEVE",
  "23DB62": "LEVE",
  "23DD62": "LEVE",
  "23DDE4": "LEVE",
  "23EA62": "LEVE",
  "23EAE4": "LEVE",
  "23EB62": "LEVE",
  "23EBE4": "LEVE",
  "23EC62": "LEVE",
  "23ED62": "LEVE",
  "23EDE4": "LEVE",
  "23EM62": "LEVE",
  "23EN62": "LEVE",
  "23EP62": "LEVE",
  "23ER62": "LEVE",
  "23FDE4": "LEVE",
  "23GDE4": "LEVE",
  "23HDE4": "LEVE",
  "23JB62": "LEVE",
  "23JBE4": "LEVE",
  "23JD62": "LEVE",
  "23JDE4": "LEVE",
  "23KB62": "LEVE",
  "23KD62": "LEVE",
  "23KDE4": "LEVE",
  "23LA62": "LEVE",
  "23LB62": "LEVE",
  "23LBE4": "LEVE",
  "23LC62": "LEVE",
  "23LD62": "LEVE",
  "23LDE4": "LEVE",
  "23LN62": "LEVE",
  "23LR62": "LEVE",
  "23MB62": "LEVE",
  "23MBE4": "LEVE",
  "23MDE4": "LEVE",
  "23NBE4": "LEVE",
  "23NCE4": "LEVE",
  "23ND62": "LEVE",
  "23NDE4": "LEVE",
  "249DE4": "LEVE",
  "24AA5B": "SEMI_PESADO",
  "24AAN4": "SEMI_PESADO",
  "24AB5B": "SEMI_PESADO",
  "24ABN4": "SEMI_PESADO",
  "24ACJ5": "SEMI_PESADO",
  "24ACN4": "SEMI_PESADO",
  "24AD5B": "SEMI_PESADO",
  "24ADE4": "LEVE",
  "24ADN4": "SEMI_PESADO",
  "24ADY5": "SEMI_PESADO",
  "24AMN4": "SEMI_PESADO",
  "24ANN4": "SEMI_PESADO",
  "24APN4": "SEMI_PESADO",
  "24ARN4": "SEMI_PESADO",
  "24BAE4": "LEVE",
  "24BAN4": "SEMI_PESADO",
  "24BB5B": "SEMI_PESADO",
  "24BBE4": "LEVE",
  "24BBN4": "SEMI_PESADO",
  "24BCE4": "LEVE",
  "24BCJ5": "SEMI_PESADO",
  "24BCN4": "SEMI_PESADO",
  "24BCY5": "SEMI_PESADO",
  "24BD5B": "SEMI_PESADO",
  "24BDE4": "LEVE",
  "24BDN4": "SEMI_PESADO",
  "24BDY5": "SEMI_PESADO",
  "24BMN4": "SEMI_PESADO",
  "24BNN4": "SEMI_PESADO",
  "24BRN4": "SEMI_PESADO",
  "24EA5B": "SEMI_PESADO",
  "24EAN4": "SEMI_PESADO",
  "24EB5B": "SEMI_PESADO",
  "24EBN4": "SEMI_PESADO",
  "24EBY5": "SEMI_PESADO",
  "24EDJ5": "SEMI_PESADO",
  "24EDN4": "SEMI_PESADO",
  "24EDY5": "SEMI_PESADO",
  "24EMN4": "SEMI_PESADO",
  "24ENN4": "SEMI_PESADO",
  "24ERN4": "SEMI_PESADO",
  "24FA5B": "SEMI_PESADO",
  "24FAN4": "SEMI_PESADO",
  "24FB5B": "SEMI_PESADO",
  "24FBN4": "SEMI_PESADO",
  "24FBY5": "SEMI_PESADO",
  "24FD5B": "SEMI_PESADO",
  "24FDJ5": "SEMI_PESADO",
  "24FDN4": "SEMI_PESADO",
  "24FDY5": "SEMI_PESADO",
  "24FMN4": "SEMI_PESADO",
  "24FNN4": "SEMI_PESADO",
  "24FRN4": "SEMI_PESADO",
  "24FRU3": "SEMI_PESADO",
  "24GAE4": "LEVE",
  "24GAG4": "SEMI_PESADO",
  "24GBE4": "LEVE",
  "24GBG4": "SEMI_PESADO",
  "24GCE4": "LEVE",
  "24GCG4": "SEMI_PESADO",
  "24GDE4": "LEVE",
  "24GDG4": "SEMI_PESADO",
  "24GMG4": "SEMI_PESADO",
  "24GNE4": "LEVE",
  "24HAG4": "SEMI_PESADO",
  "24HBG4": "SEMI_PESADO",
  "24HDG4": "SEMI_PESADO",
  "24JA5B": "SEMI_PESADO",
  "24JB53": "SEMI_PESADO",
  "24JB57": "SEMI_PESADO",
  "24JB5B": "SEMI_PESADO",
  "24JBE3": "LEVE",
  "24JBE4": "LEVE",
  "24JBG4": "SEMI_PESADO",
  "24JBN4": "SEMI_PESADO",
  "24JBY5": "SEMI_PESADO",
  "24JC5B": "SEMI_PESADO",
  "24JCG4": "SEMI_PESADO",
  "24JCY5": "SEMI_PESADO",
  "24JCYG": "SEMI_PESADO",
  "24JD53": "SEMI_PESADO",
  "24JD57": "SEMI_PESADO",
  "24JD5B": "SEMI_PESADO",
  "24JDE3": "LEVE",
  "24JDE4": "LEVE",
  "24JDG4": "SEMI_PESADO",
  "24JDN4": "SEMI_PESADO",
  "24JMJ5": "SEMI_PESADO",
  "24KA5B": "SEMI_PESADO",
  "24KB53": "SEMI_PESADO",
  "24KB57": "SEMI_PESADO",
  "24KB5B": "SEMI_PESADO",
  "24KBE3": "LEVE",
  "24KBE4": "LEVE",
  "24KBG4": "SEMI_PESADO",
  "24KBN4": "SEMI_PESADO",
  "24KBY5": "SEMI_PESADO",
  "24KCY5": "SEMI_PESADO",
  "24KD53": "SEMI_PESADO",
  "24KD57": "SEMI_PESADO",
  "24KD5B": "SEMI_PESADO",
  "24KDE3": "LEVE",
  "24KDE4": "LEVE",
  "24KDG4": "SEMI_PESADO",
  "24KDN4": "SEMI_PESADO",
  "24LA53": "SEMI_PESADO",
  "24LA57": "SEMI_PESADO",
  "24LA5B": "SEMI_PESADO",
  "24LAE3": "LEVE",
  "24LAE4": "LEVE",
  "24LAG4": "SEMI_PESADO",
  "24LB53": "SEMI_PESADO",
  "24LB57": "SEMI_PESADO",
  "24LB5B": "SEMI_PESADO",
  "24LBE3": "LEVE",
  "24LBE4": "LEVE",
  "24LBG4": "SEMI_PESADO",
  "24LBN4": "SEMI_PESADO",
  "24LBY5": "SEMI_PESADO",
  "24LC57": "SEMI_PESADO",
  "24LC5B": "SEMI_PESADO",
  "24LCG4": "SEMI_PESADO",
  "24LCJ5": "SEMI_PESADO",
  "24LCY5": "SEMI_PESADO",
  "24LD53": "SEMI_PESADO",
  "24LD57": "SEMI_PESADO",
  "24LD5B": "SEMI_PESADO",
  "24LDE3": "LEVE",
  "24LDE4": "LEVE",
  "24LDG4": "SEMI_PESADO",
  "24LDN4": "SEMI_PESADO",
  "24LMJ5": "SEMI_PESADO",
  "24MA57": "SEMI_PESADO",
  "24MA5B": "SEMI_PESADO",
  "24MB53": "SEMI_PESADO",
  "24MB57": "SEMI_PESADO",
  "24MB5B": "SEMI_PESADO",
  "24MBG4": "SEMI_PESADO",
  "24MBN4": "SEMI_PESADO",
  "24MBY5": "SEMI_PESADO",
  "24MBYG": "SEMI_PESADO",
  "24MBYT": "SEMI_PESADO",
  "24MD53": "SEMI_PESADO",
  "24MD57": "SEMI_PESADO",
  "24MD5B": "SEMI_PESADO",
  "24MDN4": "SEMI_PESADO",
  "24MDY5": "SEMI_PESADO",
  "24NA5B": "SEMI_PESADO",
  "24NB53": "SEMI_PESADO",
  "24NB57": "SEMI_PESADO",
  "24NB5B": "SEMI_PESADO",
  "24NBN4": "SEMI_PESADO",
  "24NBY5": "SEMI_PESADO",
  "24NBYG": "SEMI_PESADO",
  "24NBYT": "SEMI_PESADO",
  "24ND53": "SEMI_PESADO",
  "24ND57": "SEMI_PESADO",
  "24ND5B": "SEMI_PESADO",
  "24NDN4": "SEMI_PESADO",
  "24NDY5": "SEMI_PESADO",
  "24PA53": "SEMI_PESADO",
  "24PA57": "SEMI_PESADO",
  "24PA5B": "SEMI_PESADO",
  "24PAN4": "SEMI_PESADO",
  "24PB53": "SEMI_PESADO",
  "24PB57": "SEMI_PESADO",
  "24PB5B": "SEMI_PESADO",
  "24PBG4": "SEMI_PESADO",
  "24PBN4": "SEMI_PESADO",
  "24PBY5": "SEMI_PESADO",
  "24PBYG": "SEMI_PESADO",
  "24PBYT": "SEMI_PESADO",
  "24PD53": "SEMI_PESADO",
  "24PD57": "SEMI_PESADO",
  "24PD5B": "SEMI_PESADO",
  "24PDG4": "SEMI_PESADO",
  "24PDN4": "SEMI_PESADO",
  "24PDY5": "SEMI_PESADO",
  "24QB57": "SEMI_PESADO",
  "24QBYG": "SEMI_PESADO",
  "24QBYT": "SEMI_PESADO",
  "24QFYG": "SEMI_PESADO",
  "24QFYT": "SEMI_PESADO",
  "24RB57": "SEMI_PESADO",
  "24RB5B": "SEMI_PESADO",
  "24SA5B": "SEMI_PESADO",
  "24SAE4": "LEVE",
  "24SAY5": "SEMI_PESADO",
  "24SB53": "SEMI_PESADO",
  "24SB5B": "SEMI_PESADO",
  "24SBE4": "LEVE",
  "24SBY5": "SEMI_PESADO",
  "24SC5B": "SEMI_PESADO",
  "24SCN4": "SEMI_PESADO",
  "24SCY5": "SEMI_PESADO",
  "24SD53": "SEMI_PESADO",
  "24SD5B": "SEMI_PESADO",
  "24SDE3": "LEVE",
  "24SDE4": "LEVE",
  "24SDG4": "SEMI_PESADO",
  "24SDY5": "SEMI_PESADO",
  "24TA53": "SEMI_PESADO",
  "24TA5B": "SEMI_PESADO",
  "24TB53": "SEMI_PESADO",
  "24TB5B": "SEMI_PESADO",
  "24TBG4": "SEMI_PESADO",
  "24TBN4": "SEMI_PESADO",
  "24TBY5": "SEMI_PESADO",
  "24TD53": "SEMI_PESADO",
  "24TD5B": "SEMI_PESADO",
  "24TDG4": "SEMI_PESADO",
  "24TDY5": "SEMI_PESADO",
  "24WB57": "SEMI_PESADO",
  "24WB5B": "SEMI_PESADO",
  "262G55": "SEMI_PESADO",
  "263G55": "SEMI_PESADO",
  "264F55": "SEMI_PESADO",
  "264FB8": "SEMI_PESADO",
  "264G55": "SEMI_PESADO",
  "267F55": "SEMI_PESADO",
  "267FB8": "SEMI_PESADO",
  "267G55": "SEMI_PESADO",
  "268F55": "SEMI_PESADO",
  "268FJ5": "SEMI_PESADO",
  "268FT5": "SEMI_PESADO",
  "268FY5": "SEMI_PESADO",
  "268G55": "SEMI_PESADO",
  "268GB8": "SEMI_PESADO",
  "268GJ5": "SEMI_PESADO",
  "268GT5": "SEMI_PESADO",
  "268GY5": "SEMI_PESADO",
  "26AFB8": "SEMI_PESADO",
  "26AGB8": "SEMI_PESADO",
  "26BF55": "SEMI_PESADO",
  "26BFB8": "SEMI_PESADO",
  "26BG55": "SEMI_PESADO",
  "26BGB8": "SEMI_PESADO",
  "26CFW5": "SEMI_PESADO",
  "26CFY5": "SEMI_PESADO",
  "26CGB8": "SEMI_PESADO",
  "26CGJ5": "SEMI_PESADO",
  "26CGT5": "SEMI_PESADO",
  "26CGW5": "SEMI_PESADO",
  "26DF55": "SEMI_PESADO",
  "26DFB8": "SEMI_PESADO",
  "26DFJ5": "SEMI_PESADO",
  "26DFT5": "SEMI_PESADO",
  "26DFW5": "SEMI_PESADO",
  "26DFY5": "SEMI_PESADO",
  "26DG55": "SEMI_PESADO",
  "26DGB8": "SEMI_PESADO",
  "26DGJ5": "SEMI_PESADO",
  "26DGT5": "SEMI_PESADO",
  "26DGW5": "SEMI_PESADO",
  "26DGY5": "SEMI_PESADO",
  "26DMJ5": "SEMI_PESADO",
  "26DNJ5": "SEMI_PESADO",
  "26DNW5": "SEMI_PESADO",
  "26JF55": "SEMI_PESADO",
  "26JFY5": "SEMI_PESADO",
  "26JG55": "SEMI_PESADO",
  "26JGJ5": "SEMI_PESADO",
  "26JGT5": "SEMI_PESADO",
  "26JGY5": "SEMI_PESADO",
  "26KG55": "SEMI_PESADO",
  "26KGT5": "SEMI_PESADO",
  "26KGY5": "SEMI_PESADO",
  "26LF55": "SEMI_PESADO",
  "26LFJ5": "SEMI_PESADO",
  "26LFT5": "SEMI_PESADO",
  "26LFY5": "SEMI_PESADO",
  "26LFY8": "SEMI_PESADO",
  "26LG55": "SEMI_PESADO",
  "26LGJ5": "SEMI_PESADO",
  "26LGT5": "SEMI_PESADO",
  "26LGY5": "SEMI_PESADO",
  "26LGY8": "SEMI_PESADO",
  "26MFR9": "SEMI_PESADO",
  "26MGR9": "SEMI_PESADO",
  "271Y39": "SEMI_PESADO",
  "271YT5": "SEMI_PESADO",
  "27AYT5": "SEMI_PESADO",
  "27AYW5": "SEMI_PESADO",
  "27BYT5": "SEMI_PESADO",
  "27BYW5": "SEMI_PESADO",
  "27CA5B": "SEMI_PESADO",
  "27FA39": "SEMI_PESADO",
  "27FAJ5": "SEMI_PESADO",
  "27FAR5": "SEMI_PESADO",
  "27FAR9": "SEMI_PESADO",
  "27FARG": "SEMI_PESADO",
  "27FAT5": "SEMI_PESADO",
  "27FAY5": "SEMI_PESADO",
  "27FAY9": "SEMI_PESADO",
  "27GA39": "SEMI_PESADO",
  "27GAR5": "SEMI_PESADO",
  "27GAR9": "SEMI_PESADO",
  "27GARG": "SEMI_PESADO",
  "27GAY5": "SEMI_PESADO",
  "27GAY9": "SEMI_PESADO",
  "27HA39": "SEMI_PESADO",
  "27HAR5": "SEMI_PESADO",
  "27HAR9": "SEMI_PESADO",
  "27HARG": "SEMI_PESADO",
  "27HAT5": "SEMI_PESADO",
  "27HAY5": "SEMI_PESADO",
  "27JAJ5": "SEMI_PESADO",
  "27JAT5": "SEMI_PESADO",
  "27JAW5": "SEMI_PESADO",
  "27JAY5": "SEMI_PESADO",
  "27JMJ5": "SEMI_PESADO",
  "27KY39": "SEMI_PESADO",
  "27KYR5": "SEMI_PESADO",
  "27KYR9": "SEMI_PESADO",
  "27KYRG": "SEMI_PESADO",
  "27LAJ5": "SEMI_PESADO",
  "27LAT5": "SEMI_PESADO",
  "27LAW5": "SEMI_PESADO",
  "27LAY5": "SEMI_PESADO",
  "27LMJ5": "SEMI_PESADO",
  "27MQW6": "SEMI_PESADO",
  "27MYJ5": "SEMI_PESADO",
  "27MYT5": "SEMI_PESADO",
  "27MYW5": "SEMI_PESADO",
  "27NYJ5": "SEMI_PESADO",
  "27NYT5": "SEMI_PESADO",
  "27NYW5": "SEMI_PESADO",
  "27PAN4": "SEMI_PESADO",
  "27QAN4": "SEMI_PESADO",
  "27TY39": "SEMI_PESADO",
  "27TYR5": "SEMI_PESADO",
  "27TYR9": "SEMI_PESADO",
  "27TYRG": "SEMI_PESADO",
  "27TYT5": "SEMI_PESADO",
  "27UYT5": "SEMI_PESADO",
  "27XA39": "SEMI_PESADO",
  "27XAT5": "SEMI_PESADO",
  "27XAY5": "SEMI_PESADO",
  "27XAY9": "SEMI_PESADO",
  "27YY39": "SEMI_PESADO",
  "27YYT5": "SEMI_PESADO",
  "27YYT9": "SEMI_PESADO",
  "27ZY39": "SEMI_PESADO",
  "27ZYT5": "SEMI_PESADO",
  "27ZYT9": "SEMI_PESADO",
  "2P1MME": "LEVE",
  "2P1YM1": "LEVE",
  "2P21M1": "LEVE",
  "2P2JM1": "LEVE",
  "2P2NM1": "LEVE",
  "2P31M1": "LEVE",
  "2P4191": "LEVE",
  "2P41M1": "LEVE",
  "2P4FM1": "LEVE",
  "2P51M1": "LEVE",
  "2P5NM1": "LEVE",
  "2P5YM1": "LEVE",
  "2P6FM1": "LEVE",
  "2PA192": "LEVE",
  "2PA1M1": "LEVE",
  "2PAP81": "LEVE",
  "2PAP92": "LEVE",
  "2PAP96": "LEVE",
  "2PAT92": "LEVE",
  "2PAT96": "LEVE",
  "2PAW92": "LEVE",
  "2PAWM1": "LEVE",
  "2PBH92": "LEVE",
  "2PBHM1": "LEVE",
  "2PBS81": "LEVE",
  "2PBS91": "LEVE",
  "2PBS94": "LEVE",
  "2PBS97": "LEVE",
  "2PC191": "LEVE",
  "2PC1A1": "LEVE",
  "2PC1M1": "LEVE",
  "2PCM91": "LEVE",
  "2PCM95": "LEVE",
  "2PCMM1": "LEVE",
  "2PCN91": "LEVE",
  "2PCN95": "LEVE",
  "2PCNA1": "LEVE",
  "2PCNM1": "LEVE",
  "2PCR91": "LEVE",
  "2PCR95": "LEVE",
  "2PCT91": "LEVE",
  "2PCT95": "LEVE",
  "2PCY91": "LEVE",
  "2PCYA1": "LEVE",
  "2PCYM1": "LEVE",
  "2PD191": "LEVE",
  "2PD1M1": "LEVE",
  "2PDH91": "LEVE",
  "2PDNM1": "LEVE",
  "2PDS91": "LEVE",
  "2PDS93": "LEVE",
  "2PDT93": "LEVE",
  "2PLHM1": "LEVE",
  "2PM1M1": "LEVE",
  "2PX1A1": "LEVE",
  "2PX1M1": "LEVE",
  "2PXNA1": "LEVE",
  "2PXNM1": "LEVE",
  "2PXYA1": "LEVE",
  "2PXYM1": "LEVE",
  "2R1121": "LEVE",
  "2R1141": "LEVE",
  "2R1R21": "LEVE",
  "2R1RA1": "LEVE",
  "2R1Y21": "LEVE",
  "2R1Y41": "LEVE",
  "2R1YA1": "LEVE",
  "2R2121": "LEVE",
  "2R21A1": "LEVE",
  "2R21D1": "LEVE",
  "2R2N21": "LEVE",
  "2R2N91": "LEVE",
  "2R2NA1": "LEVE",
  "2R2ND1": "LEVE",
  "2R2R21": "LEVE",
  "2R2RA1": "LEVE",
  "2R4121": "LEVE",
  "2R4NA1": "LEVE",
  "2R4R21": "LEVE",
  "2R6RD1": "LEVE",
  "2R7ND1": "LEVE",
  "2R7RD1": "LEVE",
  "2RBMC1": "LEVE",
  "2RCMC1": "LEVE",
  "2RCNC1": "LEVE",
  "2RCPA1": "LEVE",
  "2RCPC1": "LEVE",
  "2RCRA1": "LEVE",
  "2RCRC1": "LEVE",
  "2REM41": "LEVE",
  "2REMC1": "LEVE",
  "2REN41": "LEVE",
  "2RENC1": "LEVE",
  "2REPC1": "LEVE",
  "2RER41": "LEVE",
  "2RERC1": "LEVE",
  "2RF141": "LEVE",
  "2RF1A1": "LEVE",
  "2RF1C1": "LEVE",
  "2RF1D1": "LEVE",
  "2RF1U1": "LEVE",
  "2RFM41": "LEVE",
  "2RFMA1": "LEVE",
  "2RFMC1": "LEVE",
  "2RFN41": "LEVE",
  "2RFNA1": "LEVE",
  "2RFNC1": "LEVE",
  "2RFND1": "LEVE",
  "2RFNU1": "LEVE",
  "2RFNV1": "LEVE",
  "2RFPA1": "LEVE",
  "2RFRA1": "LEVE",
  "2RFY41": "LEVE",
  "2RFYC1": "LEVE",
  "2RGMD1": "LEVE",
  "2RGND1": "LEVE",
  "2RGPD1": "LEVE",
  "2RGRD1": "LEVE",
  "2RHNA1": "LEVE",
  "2RHRA1": "LEVE",
  "2RJMD1": "LEVE",
  "2RJND1": "LEVE",
  "2RJPD1": "LEVE",
  "2RJRD1": "LEVE",
  "2RKP41": "LEVE",
  "2RKPC1": "LEVE",
  "2RKR41": "LEVE",
  "2RLPD1": "LEVE",
  "2RLRD1": "LEVE",
  "2RMRA1": "LEVE",
  "2RNND1": "LEVE",
  "2RNRD1": "LEVE",
  "2RPPD1": "LEVE",
  "2RRR21": "LEVE",
  "2RRRA1": "LEVE",
  "2RSRA1": "LEVE",
  "2RW1A1": "LEVE",
  "2RWNA1": "LEVE",
  "2RWRA1": "LEVE",
  "2RX1A1": "LEVE",
  "2RX1U1": "LEVE",
  "2RXNA1": "LEVE",
  "2RXNU1": "LEVE",
  "2RXNV1": "LEVE",
  "2RXRA1": "LEVE",
  "2RXYV1": "LEVE",
  "2RY1A1": "LEVE",
  "2RY1D1": "LEVE",
  "2RYMD1": "LEVE",
  "2RYNA1": "LEVE",
  "2RYND1": "LEVE",
  "2RYYA1": "LEVE",
  "2RYYD1": "LEVE",
  "2RZN21": "LEVE",
  "2RZN81": "LEVE",
  "2RZN91": "LEVE",
  "2RZNA1": "LEVE",
  "2RZND1": "LEVE",
  "2RZNU1": "LEVE",
  "2SEA11": "LEVE",
  "2SEAP1": "LEVE",
  "2SEB11": "LEVE",
  "2SEC11": "LEVE",
  "2SED11": "LEVE",
  "2SED51": "LEVE",
  "2SED61": "LEVE",
  "2SEDH1": "LEVE",
  "2SEM61": "LEVE",
  "2SEN61": "LEVE",
  "2SENH1": "LEVE",
  "2SER61": "LEVE",
  "2SERH1": "LEVE",
  "2SHM11": "LEVE",
  "2SHMD1": "LEVE",
  "2SHME1": "LEVE",
  "2SHMH1": "LEVE",
  "2SHMS1": "LEVE",
  "2SHN11": "LEVE",
  "2SHNE1": "LEVE",
  "2SHNS1": "LEVE",
  "2SHP11": "LEVE",
  "2SHPD1": "LEVE",
  "2SHPE1": "LEVE",
  "2SHPS1": "LEVE",
  "2SHR11": "LEVE",
  "2SHRD1": "LEVE",
  "2SHRE1": "LEVE",
  "2SHRH1": "LEVE",
  "2SHRS1": "LEVE",
  "2SKM11": "LEVE",
  "2SKME1": "LEVE",
  "2SKMH1": "LEVE",
  "2SKMS1": "LEVE",
  "2SKN11": "LEVE",
  "2SKNE1": "LEVE",
  "2SKNH1": "LEVE",
  "2SKNS1": "LEVE",
  "2SKP11": "LEVE",
  "2SKPE1": "LEVE",
  "2SKPH1": "LEVE",
  "2SKPS1": "LEVE",
  "2SKR11": "LEVE",
  "2SKRE1": "LEVE",
  "2SKRH1": "LEVE",
  "2SKRS1": "LEVE",
  "2SLA11": "LEVE",
  "2SLA61": "LEVE",
  "2SLAE1": "LEVE",
  "2SLAH1": "LEVE",
  "2SLB11": "LEVE",
  "2SLB41": "LEVE",
  "2SLB61": "LEVE",
  "2SLBE1": "LEVE",
  "2SLBH1": "LEVE",
  "2SLC11": "SEMI_PESADO",
  "2SLCE1": "LEVE",
  "2SLCP1": "LEVE",
  "2SLD11": "LEVE",
  "2SLD41": "LEVE",
  "2SLD51": "LEVE",
  "2SLD61": "LEVE",
  "2SLDE1": "LEVE",
  "2SLDH1": "LEVE",
  "2SLDP1": "LEVE",
  "2SLM61": "LEVE",
  "2SLMH1": "LEVE",
  "2SLN61": "LEVE",
  "2SLNH1": "LEVE",
  "2SLP61": "LEVE",
  "2SLR61": "LEVE",
  "2SLRH1": "LEVE",
  "2TAA72": "SEMI_PESADO",
  "2TAM72": "SEMI_PESADO",
  "2TAMM2": "SEMI_PESADO",
  "2TBA12": "LEVE",
  "2TBA72": "SEMI_PESADO",
  "2TBAM2": "SEMI_PESADO",
  "2TBAN2": "SEMI_PESADO",
  "2TBB12": "LEVE",
  "2TBB32": "SEMI_PESADO",
  "2TBB72": "SEMI_PESADO",
  "2TBBM2": "SEMI_PESADO",
  "2TBBN2": "SEMI_PESADO",
  "2TBC12": "LEVE",
  "2TBC72": "SEMI_PESADO",
  "2TBCM2": "SEMI_PESADO",
  "2TBCN2": "SEMI_PESADO",
  "2TBCR4": "SEMI_PESADO",
  "2TBD12": "LEVE",
  "2TBD72": "SEMI_PESADO",
  "2TBDM2": "SEMI_PESADO",
  "2TBDN2": "SEMI_PESADO",
  "2TBDR4": "SEMI_PESADO",
  "2TBE12": "LEVE",
  "2TBM11": "LEVE",
  "2TBM72": "SEMI_PESADO",
  "2TBMF1": "SEMI_PESADO",
  "2TBMK1": "SEMI_PESADO",
  "2TBMM2": "SEMI_PESADO",
  "2TBMN9": "SEMI_PESADO",
  "2TBN11": "LEVE",
  "2TBNF1": "SEMI_PESADO",
  "2TBNK1": "SEMI_PESADO",
  "2TBNM2": "SEMI_PESADO",
  "2TBNN9": "SEMI_PESADO",
  "2TBNR4": "SEMI_PESADO",
  "2TBP72": "SEMI_PESADO",
  "2TBPF1": "SEMI_PESADO",
  "2TBPK1": "SEMI_PESADO",
  "2TBPM2": "SEMI_PESADO",
  "2TBPR4": "SEMI_PESADO",
  "2TBR11": "LEVE",
  "2TBR72": "SEMI_PESADO",
  "2TBRF1": "SEMI_PESADO",
  "2TBRK1": "SEMI_PESADO",
  "2TBRM2": "SEMI_PESADO",
  "2TBRN9": "SEMI_PESADO",
  "2TBRR4": "SEMI_PESADO",
  "2TBUN2": "SEMI_PESADO",
  "2TCMR6": "SEMI_PESADO",
  "2TDAH6": "SEMI_PESADO",
  "2TDAR6": "SEMI_PESADO",
  "2TDMP5": "SEMI_PESADO",
  "2TDMR6": "SEMI_PESADO",
  "2TEMF1": "SEMI_PESADO",
  "2TEMM2": "SEMI_PESADO",
  "2TEMN9": "SEMI_PESADO",
  "2TRA72": "SEMI_PESADO",
  "2TRAM2": "SEMI_PESADO",
  "2TRAN2": "SEMI_PESADO",
  "2TRAR4": "SEMI_PESADO",
  "2TRB72": "SEMI_PESADO",
  "2TRBM2": "SEMI_PESADO",
  "2TRBN2": "SEMI_PESADO",
  "2TRD42": "SEMI_PESADO",
  "2TRD72": "SEMI_PESADO",
  "2TRDM2": "SEMI_PESADO",
  "2TRDN2": "SEMI_PESADO",
  "2TRDR4": "SEMI_PESADO",
  "2TRM72": "SEMI_PESADO",
  "2TRMN9": "SEMI_PESADO",
  "2TRMR4": "SEMI_PESADO",
  "2TRN72": "SEMI_PESADO",
  "2TRNN9": "SEMI_PESADO",
  "2TRR72": "SEMI_PESADO",
  "2TRRM2": "SEMI_PESADO",
  "2TRRN9": "SEMI_PESADO",
  "2TRRR4": "SEMI_PESADO",
  "2TTMF1": "SEMI_PESADO",
  "2TTMK1": "SEMI_PESADO",
  "2TTMM2": "SEMI_PESADO",
  "2TTMN9": "SEMI_PESADO",
  "2TTMR4": "SEMI_PESADO",
  "2TTNF1": "SEMI_PESADO",
  "2TTNK1": "SEMI_PESADO",
  "2TTNM2": "SEMI_PESADO",
  "2TTNN9": "SEMI_PESADO",
  "2TTNR4": "SEMI_PESADO",
  "2TTRF1": "SEMI_PESADO",
  "2TTRK1": "SEMI_PESADO",
  "2TTRM2": "SEMI_PESADO",
  "2TTRN9": "SEMI_PESADO",
  "2TTRR4": "SEMI_PESADO",
  "2UBFB1": "SEMI_PESADO",
  "2UBFR1": "SEMI_PESADO",
  "2UBGB1": "SEMI_PESADO",
  "2UBGR1": "SEMI_PESADO",
  "2UBMB4": "SEMI_PESADO",
  "2UBMR1": "SEMI_PESADO",
  "2UBMR4": "SEMI_PESADO",
  "2UBMR5": "SEMI_PESADO",
  "2UBMT4": "SEMI_PESADO",
  "2UBNB4": "SEMI_PESADO",
  "2UBNR1": "SEMI_PESADO",
  "2UBNR4": "SEMI_PESADO",
  "2UBNR5": "SEMI_PESADO",
  "2UBNT4": "SEMI_PESADO",
  "2UFMM4": "SEMI_PESADO",
  "2UFMN4": "SEMI_PESADO",
  "2UFNM4": "SEMI_PESADO",
  "2UFNN4": "SEMI_PESADO",
  "2UMF71": "SEMI_PESADO",
  "2UMFB1": "SEMI_PESADO",
  "2UMFT1": "SEMI_PESADO",
  "2UMG71": "SEMI_PESADO",
  "2UMGB1": "SEMI_PESADO",
  "2UMGT1": "SEMI_PESADO",
  "2UMM75": "SEMI_PESADO",
  "2UMMB4": "SEMI_PESADO",
  "2UMMM4": "SEMI_PESADO",
  "2UMMR5": "SEMI_PESADO",
  "2UMMT1": "SEMI_PESADO",
  "2UMMT4": "SEMI_PESADO",
  "2UMN75": "SEMI_PESADO",
  "2UMNB4": "SEMI_PESADO",
  "2UMNM4": "SEMI_PESADO",
  "2UMNR5": "SEMI_PESADO",
  "2UMNT1": "SEMI_PESADO",
  "2UMNT4": "SEMI_PESADO",
  "2W8KSB": "SEMI_PESADO",
  "2WKJ81": "LEVE",
  "2WKJEB": "LEVE",
  "2WKK81": "LEVE",
  "2WKKEB": "LEVE",
  "2WLJ81": "LEVE",
  "2WLJ8B": "LEVE",
  "2WLJE1": "LEVE",
  "2WLJEB": "LEVE",
  "2WLK81": "LEVE",
  "2WLKE1": "LEVE",
  "2WLM61": "LEVE",
  "2WLM81": "LEVE",
  "2WLQ81": "LEVE",
  "2WMKEB": "LEVE",
  "2WXJF1": "SEMI_PESADO",
  "2WXJL1": "SEMI_PESADO",
  "2WXJSA": "SEMI_PESADO",
  "2WXJSB": "SEMI_PESADO",
  "2WXKBB": "SEMI_PESADO",
  "2WXKF1": "SEMI_PESADO",
  "2WXKKA": "SEMI_PESADO",
  "2WXKKB": "SEMI_PESADO",
  "2WXKL1": "SEMI_PESADO",
  "2WXKLA": "SEMI_PESADO",
  "2WXKLB": "SEMI_PESADO",
  "2WXKSA": "SEMI_PESADO",
  "2WXKSB": "SEMI_PESADO",
  "2WXMF1": "SEMI_PESADO",
  "2WXML1": "SEMI_PESADO",
  "2WXMP2": "SEMI_PESADO",
  "2WXNF1": "SEMI_PESADO",
  "2WXNL1": "SEMI_PESADO",
  "2WXNP1": "SEMI_PESADO",
  "2WXNP2": "SEMI_PESADO",
  "2WYMF1": "SEMI_PESADO",
  "2WYNF1": "SEMI_PESADO",
  "2ZMQY1": "SEMI_PESADO",
  "2ZYL51": "SEMI_PESADO",
  "2ZYL58": "SEMI_PESADO",
  "2ZYL5A": "SEMI_PESADO",
  "2ZYLB1": "SEMI_PESADO",
  "2ZYLBA": "SEMI_PESADO",
  "2ZYMB1": "SEMI_PESADO",
  "2ZYNB1": "SEMI_PESADO",
  "2ZYNB4": "SEMI_PESADO",
  "2ZYNB7": "SEMI_PESADO",
  "2ZYNB8": "SEMI_PESADO",
  "2ZYNG1": "SEMI_PESADO",
  "2ZYNG3": "SEMI_PESADO",
  "2ZYNG4": "SEMI_PESADO",
  "2ZYQ51": "SEMI_PESADO",
  "2ZYQ58": "SEMI_PESADO",
  "2ZYQ5A": "SEMI_PESADO",
  "2ZYQB1": "SEMI_PESADO",
  "2ZYQB8": "SEMI_PESADO",
  "2ZYQBA": "SEMI_PESADO",
  "2ZZLJ1": "SEMI_PESADO",
  "2ZZLR1": "SEMI_PESADO",
  "2ZZLY1": "SEMI_PESADO",
  "2ZZMJ1": "SEMI_PESADO",
  "2ZZMR1": "SEMI_PESADO",
  "2ZZMR7": "SEMI_PESADO",
  "S35DE4": "LEVE",
  "S36BE4": "LEVE",
  "S36CE4": "LEVE",
  "S36DE4": "LEVE",
  "S48L5A": "SEMI_PESADO",
  "S4ZL58": "SEMI_PESADO",
  "S4ZL5A": "SEMI_PESADO",
  "S4ZL5C": "SEMI_PESADO",
  "S51AE4": "LEVE",
  "S51AG4": "SEMI_PESADO",
  "S51BE4": "LEVE",
  "S51BG4": "SEMI_PESADO",
  "S51CG4": "SEMI_PESADO",
  "S51DE4": "LEVE",
  "S51DG4": "SEMI_PESADO",
  "S51NE4": "LEVE",
  "S52BG4": "SEMI_PESADO",
  "S52DG4": "SEMI_PESADO",
  "TA2589": "SEMI_PESADO",
  "TAV589": "SEMI_PESADO",
  "TBCRH1": "LEVE",
  "TBCSH1": "LEVE",
  "TBCTH1": "LEVE",
  "TBERE1": "LEVE",
  "TBERE3": "LEVE",
  "TBERS1": "LEVE",
  "TBERV1": "LEVE",
  "TBERV3": "LEVE",
  "TBESE1": "LEVE",
  "TBESE3": "LEVE",
  "TBESEL": "LEVE",
  "TBESN1": "LEVE",
  "TBESS1": "LEVE",
  "TBESS3": "LEVE",
  "TBESV1": "LEVE",
  "TBESV3": "LEVE",
  "TBETE1": "LEVE",
  "TBETE3": "LEVE",
  "TBETS1": "LEVE",
  "TBETS3": "LEVE",
  "TBETV1": "LEVE",
  "TBETV3": "LEVE",
  "TBEUE1": "LEVE",
  "TBEUE3": "LEVE",
  "TBEUN1": "LEVE",
  "TBEUN3": "LEVE",
  "TBEUS1": "LEVE",
  "TBEUS3": "LEVE",
  "TBEUV1": "LEVE",
  "TBEUV3": "LEVE",
  "TBJGE1": "LEVE",
  "TBJHE1": "LEVE",
  "TBJTE1": "LEVE",
  "TBNGV1": "LEVE",
  "TBNHV1": "LEVE",
  "TBQRC1": "LEVE",
  "TBQSC1": "LEVE",
  "TBSEP1": "LEVE",
  "TBSVP1": "LEVE",
  "TBTVP1": "LEVE",
  "TBXRE1": "LEVE",
  "TBXRE3": "LEVE",
  "TBXRH1": "LEVE",
  "TBXRH3": "LEVE",
  "TBXSE1": "LEVE",
  "TBXSE3": "LEVE",
  "TBXSH1": "LEVE",
  "TBXSH3": "LEVE",
  "TBXSS1": "LEVE",
  "TBXSS3": "LEVE",
  "TBXTE1": "LEVE",
  "TBXTE3": "LEVE",
  "TBXTH1": "LEVE",
  "TBXTH3": "LEVE",
  "TBXTN1": "LEVE",
  "TBXTN3": "LEVE",
  "TBXTS1": "LEVE",
  "TBXTS3": "LEVE",
  "TBXUE1": "LEVE",
  "TBXUE3": "LEVE",
  "TBXUH1": "LEVE",
  "TBXUH3": "LEVE",
  "TBXUN1": "LEVE",
  "TBXUN3": "LEVE",
  "TBXUS1": "LEVE",
  "TBXUS3": "LEVE",
  "TCQRC1": "LEVE",
  "TCQS51": "LEVE",
  "TCQS61": "LEVE",
  "TCQSC1": "LEVE",
  "TCQSJ1": "LEVE",
  "TCTEC1": "LEVE",
  "TCTEP1": "LEVE",
  "TCTVC1": "LEVE",
  "TCTVP1": "LEVE",
  "TD1AB6": "SEMI_PESADO",
  "TD1ABB": "SEMI_PESADO",
  "TD1B4B": "SEMI_PESADO",
  "TD1BB4": "SEMI_PESADO",
  "TD1BB6": "SEMI_PESADO",
  "TD1BBB": "SEMI_PESADO",
  "TD1BCB": "SEMI_PESADO",
  "TD1BCG": "SEMI_PESADO",
  "TD1BEG": "SEMI_PESADO",
  "TD1DB6": "SEMI_PESADO",
  "TD1DCB": "SEMI_PESADO",
  "TD1DCG": "SEMI_PESADO",
  "TD2AB6": "SEMI_PESADO",
  "TD2ABB": "SEMI_PESADO",
  "TD2BB6": "SEMI_PESADO",
  "TD2BBB": "SEMI_PESADO",
  "TD2BCB": "SEMI_PESADO",
  "TD2BCG": "SEMI_PESADO",
  "TD2BEG": "SEMI_PESADO",
  "TD2DB6": "SEMI_PESADO",
  "TD2DBB": "SEMI_PESADO",
  "TD2DBG": "SEMI_PESADO",
  "TD2DCB": "SEMI_PESADO",
  "TD2DCG": "SEMI_PESADO",
  "TD3AB6": "SEMI_PESADO",
  "TD3BB4": "SEMI_PESADO",
  "TD3BB6": "SEMI_PESADO",
  "TD3BBB": "SEMI_PESADO",
  "TD3BCB": "SEMI_PESADO",
  "TD3BCG": "SEMI_PESADO",
  "TD3BD6": "SEMI_PESADO",
  "TD3BEG": "SEMI_PESADO",
  "TD3DB6": "SEMI_PESADO",
  "TD3DBB": "SEMI_PESADO",
  "TD3DCB": "SEMI_PESADO",
  "TD3DCG": "SEMI_PESADO",
  "TD3DDB": "SEMI_PESADO",
  "TD3DEB": "SEMI_PESADO",
  "TD3MB8": "SEMI_PESADO",
  "TD3MBN": "SEMI_PESADO",
  "TD4ECB": "SEMI_PESADO",
  "TD4ECG": "SEMI_PESADO",
  "TD4FCB": "SEMI_PESADO",
  "TD4FCG": "SEMI_PESADO",
  "TD5ECB": "SEMI_PESADO",
  "TD5ECG": "SEMI_PESADO",
  "TD5FCG": "SEMI_PESADO",
  "TD6ECB": "SEMI_PESADO",
  "TD6ECG": "SEMI_PESADO",
  "TD6FCB": "SEMI_PESADO",
  "TD6FCG": "SEMI_PESADO",
  "TDFA74": "SEMI_PESADO",
  "TDFA7M": "SEMI_PESADO",
  "TDFAB6": "SEMI_PESADO",
  "TDFABB": "SEMI_PESADO",
  "TDFABG": "SEMI_PESADO",
  "TDFB74": "SEMI_PESADO",
  "TDFB7M": "SEMI_PESADO",
  "TDFBB6": "SEMI_PESADO",
  "TDFBBB": "SEMI_PESADO",
  "TDFBCB": "SEMI_PESADO",
  "TDFBCG": "SEMI_PESADO",
  "TDFBDB": "SEMI_PESADO",
  "TDFBEB": "SEMI_PESADO",
  "TDFBEG": "SEMI_PESADO",
  "TDFBJ4": "SEMI_PESADO",
  "TDFCB6": "SEMI_PESADO",
  "TDFCCB": "SEMI_PESADO",
  "TDFCEB": "SEMI_PESADO",
  "TDFD4B": "SEMI_PESADO",
  "TDFD74": "SEMI_PESADO",
  "TDFD7M": "SEMI_PESADO",
  "TDFDB4": "SEMI_PESADO",
  "TDFDB6": "SEMI_PESADO",
  "TDFDBB": "SEMI_PESADO",
  "TDFDBG": "SEMI_PESADO",
  "TDFDCB": "SEMI_PESADO",
  "TDFDCG": "SEMI_PESADO",
  "TDFDD6": "SEMI_PESADO",
  "TDFDDB": "SEMI_PESADO",
  "TDFDDG": "SEMI_PESADO",
  "TDFDEB": "SEMI_PESADO",
  "TDFDEG": "SEMI_PESADO",
  "TDFDJ4": "SEMI_PESADO",
  "TDFRB8": "SEMI_PESADO",
  "TDFRBN": "SEMI_PESADO",
  "TDHB74": "SEMI_PESADO",
  "TDHB7M": "SEMI_PESADO",
  "TDHBB6": "SEMI_PESADO",
  "TDHBBB": "SEMI_PESADO",
  "TDHBCG": "SEMI_PESADO",
  "TDHD74": "SEMI_PESADO",
  "TDHD7M": "SEMI_PESADO",
  "TDHDB6": "SEMI_PESADO",
  "TDHDBB": "SEMI_PESADO",
  "TDHDCB": "SEMI_PESADO",
  "TDHDCG": "SEMI_PESADO",
  "TDLA74": "SEMI_PESADO",
  "TDLA7M": "SEMI_PESADO",
  "TDLB74": "SEMI_PESADO",
  "TDLB7M": "SEMI_PESADO",
  "TDLBB6": "SEMI_PESADO",
  "TDLBBB": "SEMI_PESADO",
  "TDLBCB": "SEMI_PESADO",
  "TDLBCG": "SEMI_PESADO",
  "TDLBEB": "SEMI_PESADO",
  "TDLBEG": "SEMI_PESADO",
  "TDLCCB": "SEMI_PESADO",
  "TDLD4G": "SEMI_PESADO",
  "TDLD74": "SEMI_PESADO",
  "TDLD7M": "SEMI_PESADO",
  "TDLDB6": "SEMI_PESADO",
  "TDLDBB": "SEMI_PESADO",
  "TDLDCB": "SEMI_PESADO",
  "TDLDCG": "SEMI_PESADO",
  "TESE51": "LEVE",
  "TESEP1": "LEVE",
  "TESV51": "LEVE",
  "TESVP1": "LEVE",
  "TF96D1": "LEVE",
  "TFA1D1": "LEVE",
  "TFP2D1": "LEVE",
  "TFP3D1": "LEVE",
  "TFP3R1": "LEVE",
  "TFP4D1": "LEVE",
  "TFP4N1": "LEVE",
  "TFP4R1": "LEVE",
  "TFP5D1": "LEVE",
  "TFP5R1": "LEVE",
  "TFZ3D1": "LEVE",
  "TFZ3N1": "LEVE",
  "TFZ3R1": "LEVE",
  "TFZ6D1": "LEVE",
  "TFZ6N1": "LEVE",
  "TG3B74": "SEMI_PESADO",
  "TG3D74": "SEMI_PESADO",
  "TG3DJ4": "SEMI_PESADO",
  "TG3DT4": "SEMI_PESADO",
  "TG5D74": "SEMI_PESADO",
  "TG6B74": "SEMI_PESADO",
  "TG6D74": "SEMI_PESADO",
  "TG6DT4": "SEMI_PESADO",
  "TGK1V6": "SEMI_PESADO",
  "TGX1V6": "SEMI_PESADO",
  "TH1B9G": "EXTRA_PESADO",
  "TH1BJG": "EXTRA_PESADO",
  "TH1BWG": "EXTRA_PESADO",
  "TH1PJG": "EXTRA_PESADO",
  "TH1V9G": "EXTRA_PESADO",
  "TH1V9H": "EXTRA_PESADO",
  "TH1VJG": "EXTRA_PESADO",
  "TH1W9G": "EXTRA_PESADO",
  "TH1WJG": "EXTRA_PESADO",
  "TH1WJH": "EXTRA_PESADO",
  "TH1WWG": "EXTRA_PESADO",
  "TH2B9G": "EXTRA_PESADO",
  "TH2V9G": "EXTRA_PESADO",
  "TH2VJG": "EXTRA_PESADO",
  "TH5BJG": "EXTRA_PESADO",
  "TH5PJG": "EXTRA_PESADO",
  "TH5VJG": "EXTRA_PESADO",
  "TH5WJG": "EXTRA_PESADO",
  "TJ3VBG": "EXTRA_PESADO",
  "TJ4BBG": "EXTRA_PESADO",
  "TJ4BBH": "EXTRA_PESADO",
  "TJ4BKG": "EXTRA_PESADO",
  "TJ4BKH": "EXTRA_PESADO",
  "TJ4BYG": "EXTRA_PESADO",
  "TJ4VBG": "EXTRA_PESADO",
  "TJ4VBH": "EXTRA_PESADO",
  "TJ4VKG": "EXTRA_PESADO",
  "TJ4VKH": "EXTRA_PESADO",
  "TJ4VYG": "EXTRA_PESADO",
  "TJ4WBG": "EXTRA_PESADO",
  "TJ4WBH": "EXTRA_PESADO",
  "TJ4WKG": "EXTRA_PESADO",
  "TK1VJG": "EXTRA_PESADO",
  "TK22JG": "EXTRA_PESADO",
  "TK27JG": "EXTRA_PESADO",
  "TK2CLG": "EXTRA_PESADO",
  "TK2VJG": "EXTRA_PESADO",
  "TK2VLG": "EXTRA_PESADO",
  "TK3CJG": "EXTRA_PESADO",
  "TK3VJG": "EXTRA_PESADO",
  "TK4CJG": "EXTRA_PESADO",
  "TK4CKG": "EXTRA_PESADO",
  "TK4CLG": "EXTRA_PESADO",
  "TK4VJG": "EXTRA_PESADO",
  "TK5WMG": "EXTRA_PESADO",
  "TK5WNG": "EXTRA_PESADO",
  "TK6WMG": "EXTRA_PESADO",
  "TK6WNG": "EXTRA_PESADO",
  "TKB2KG": "EXTRA_PESADO",
  "TKB2WG": "EXTRA_PESADO",
  "TKBCKG": "EXTRA_PESADO",
  "TKBWWG": "EXTRA_PESADO",
  "TKCW9G": "EXTRA_PESADO",
  "TKCW9H": "EXTRA_PESADO",
  "TKCWJG": "EXTRA_PESADO",
  "TKGW9G": "EXTRA_PESADO",
  "TKGW9H": "EXTRA_PESADO",
  "TKGWJG": "EXTRA_PESADO",
  "TKGWKG": "EXTRA_PESADO",
  "TKGWWG": "EXTRA_PESADO",
  "TKS2JG": "EXTRA_PESADO",
  "TKSV9G": "EXTRA_PESADO",
  "TKSVJG": "EXTRA_PESADO",
  "TKSVWG": "EXTRA_PESADO",
  "TLKUBB": "SEMI_PESADO",
  "TLWDFG": "SEMI_PESADO",
  "TLWDHG": "SEMI_PESADO",
  "TLWGFG": "SEMI_PESADO",
  "TLWGHG": "SEMI_PESADO",
  "TLYDBB": "SEMI_PESADO",
  "TLYDCB": "SEMI_PESADO",
  "TLYDDB": "SEMI_PESADO",
  "TLYGBB": "SEMI_PESADO",
  "TLYGCB": "SEMI_PESADO",
  "TLYGDB": "SEMI_PESADO",
  "TLZDCB": "SEMI_PESADO",
  "TLZDCG": "SEMI_PESADO",
  "TLZDEG": "SEMI_PESADO",
  "TLZGCB": "SEMI_PESADO",
  "TLZGCG": "SEMI_PESADO",
  "TLZGEG": "SEMI_PESADO",
  "TM2589": "SEMI_PESADO",
  "TMA589": "SEMI_PESADO",
  "TMA5A9": "EXTRA_PESADO",
  "TMB589": "SEMI_PESADO",
  "TMV589": "SEMI_PESADO",
  "TMV5A9": "EXTRA_PESADO",
  "TP5Y7Y": "ELETRICO",
  "TPET7Y": "ELETRICO",
  "TPET9Y": "ELETRICO",
  "TPEY7Y": "ELETRICO",
  "TPEY9Y": "ELETRICO",
  "TRFLE8": "SEMI_PESADO",
  "TRFLG8": "SEMI_PESADO",
  "TRHLED": "SEMI_PESADO",
  "TRHLGD": "SEMI_PESADO",
  "TSBYHG": "SEMI_PESADO",
  "TSBYXG": "SEMI_PESADO",
  "TSCYHG": "SEMI_PESADO",
  "TSCYXG": "SEMI_PESADO",
  "TSHAFG": "SEMI_PESADO",
  "TSHAHG": "SEMI_PESADO",
  "TSHAXG": "SEMI_PESADO",
  "TSLAFG": "SEMI_PESADO",
  "TSLAHG": "SEMI_PESADO",
  "TUC59D": "SEMI_PESADO",
  "TUC69B": "SEMI_PESADO",
  "TUCJ9B": "SEMI_PESADO",
  "TUCJ9D": "SEMI_PESADO",
  "TUKX91": "SEMI_PESADO",
  "TUQXAB": "SEMI_PESADO",
  "TUQXAD": "SEMI_PESADO",
  "TUQXFB": "SEMI_PESADO",
  "TUQXFD": "SEMI_PESADO",
  "TUQXZB": "SEMI_PESADO",
  "TURX91": "SEMI_PESADO",
  "TUSXAB": "SEMI_PESADO",
  "TUSXAD": "SEMI_PESADO",
  "TUSXFB": "SEMI_PESADO",
  "TUSXFD": "SEMI_PESADO",
  "TUV59B": "SEMI_PESADO",
  "TUV5JD": "SEMI_PESADO",
  "TUVJ9B": "SEMI_PESADO",
  "TUVJ9D": "SEMI_PESADO",
  "TUVJJB": "SEMI_PESADO",
  "TUVJJD": "SEMI_PESADO",
  "TZUL9Z": "ELETRICO",
  "U35BE4": "LEVE",
  "U35DE4": "LEVE",
  "U36BE4": "LEVE",
  "U36CE4": "LEVE",
  "U36DE4": "LEVE",
  "U3HDE4": "LEVE",
  "U3NBE4": "LEVE",
  "U3NCE4": "LEVE",
  "U3NDE4": "LEVE",
  "U4JBG4": "SEMI_PESADO",
  "U4JDK4": "SEMI_PESADO",
  "U4KDK4": "SEMI_PESADO",
  "U4LAE4": "LEVE",
  "U4LAG4": "SEMI_PESADO",
  "U4LBE4": "LEVE",
  "U4LBG4": "SEMI_PESADO",
  "U4LBK4": "SEMI_PESADO",
  "U4LCG4": "SEMI_PESADO",
  "U4LDE4": "LEVE",
  "U4LDG4": "SEMI_PESADO",
  "U4LDK4": "SEMI_PESADO",
  "U4LRK4": "SEMI_PESADO",
  "U4LRK5": "SEMI_PESADO",
  "U4MBK4": "SEMI_PESADO",
  "U4NBK4": "SEMI_PESADO",
  "U4PAG4": "SEMI_PESADO",
  "U4PBG4": "SEMI_PESADO",
  "U4PBK4": "SEMI_PESADO",
  "U4PBK6": "SEMI_PESADO",
  "U4PDG4": "SEMI_PESADO",
  "U4PHK4": "SEMI_PESADO",
  "U4PHK5": "SEMI_PESADO",
};

const MODEL_NUMBER_PATTERN = /(\d{1,2}\.\d{3})/;

export const vehicleModelTypeByModelNumber: Record<string, VehicleModelType> = {
  "10.160": "LEVE",
  "11.180": "LEVE",
  "13.160": "LEVE",
  "13.180": "LEVE",
  "13.190": "LEVE",
  "14.190": "LEVE",
  "14.210": "SEMI_PESADO",
  "15.180": "LEVE",
  "15.190": "LEVE",
  "15.210": "SEMI_PESADO",
  "17.190": "LEVE",
  "17.210": "SEMI_PESADO",
  "17.230": "SEMI_PESADO",
  "17.250": "SEMI_PESADO",
  "17.260": "SEMI_PESADO",
  "17.280": "SEMI_PESADO",
  "17.320": "SEMI_PESADO",
  "17.330": "SEMI_PESADO",
  "18.210": "SEMI_PESADO",
  "18.260": "SEMI_PESADO",
  "18.280": "SEMI_PESADO",
  "18.320": "SEMI_PESADO",
  "18.330": "SEMI_PESADO",
  "19.320": "SEMI_PESADO",
  "19.330": "SEMI_PESADO",
  "19.360": "SEMI_PESADO",
  "19.380": "SEMI_PESADO",
  "19.390": "SEMI_PESADO",
  "19.420": "SEMI_PESADO",
  "20.480": "EXTRA_PESADO",
  "20.500": "EXTRA_PESADO",
  "23.230": "SEMI_PESADO",
  "24.250": "SEMI_PESADO",
  "24.260": "SEMI_PESADO",
  "24.280": "SEMI_PESADO",
  "24.330": "SEMI_PESADO",
  "25.360": "SEMI_PESADO",
  "25.380": "SEMI_PESADO",
  "25.390": "SEMI_PESADO",
  "25.420": "SEMI_PESADO",
  "25.460": "EXTRA_PESADO",
  "25.480": "EXTRA_PESADO",
  "25.500": "EXTRA_PESADO",
  "26.260": "SEMI_PESADO",
  "26.280": "SEMI_PESADO",
  "26.320": "SEMI_PESADO",
  "26.330": "SEMI_PESADO",
  "26.370": "SEMI_PESADO",
  "26.390": "SEMI_PESADO",
  "26.420": "SEMI_PESADO",
  "26.460": "EXTRA_PESADO",
  "26.480": "EXTRA_PESADO",
  "27.260": "SEMI_PESADO",
  "27.320": "SEMI_PESADO",
  "28.440": "SEMI_PESADO",
  "28.460": "EXTRA_PESADO",
  "28.480": "EXTRA_PESADO",
  "29.440": "SEMI_PESADO",
  "29.480": "EXTRA_PESADO",
  "29.520": "EXTRA_PESADO",
  "29.530": "EXTRA_PESADO",
  "30.280": "SEMI_PESADO",
  "30.320": "SEMI_PESADO",
  "30.330": "SEMI_PESADO",
  "31.260": "SEMI_PESADO",
  "31.280": "SEMI_PESADO",
  "31.310": "SEMI_PESADO",
  "31.320": "SEMI_PESADO",
  "31.330": "SEMI_PESADO",
  "31.390": "SEMI_PESADO",
  "32.360": "SEMI_PESADO",
  "32.380": "SEMI_PESADO",
  "33.260": "SEMI_PESADO",
  "33.440": "SEMI_PESADO",
  "33.460": "EXTRA_PESADO",
  "33.480": "EXTRA_PESADO",
  "33.520": "EXTRA_PESADO",
  "33.540": "EXTRA_PESADO",
  "4.150": "LEVE",
  "4.160": "LEVE",
  "5.120": "LEVE",
  "5.140": "LEVE",
  "5.150": "LEVE",
  "6.160": "LEVE",
  "6.170": "LEVE",
  "8.120": "LEVE",
  "8.150": "LEVE",
  "8.160": "LEVE",
  "8.170": "LEVE",
  "8.180": "LEVE",
  "9.150": "LEVE",
  "9.160": "LEVE",
  "9.170": "LEVE",
  "9.180": "LEVE",
};

export const getVehicleModelTypeByDescription = (description?: string): VehicleModelType | undefined => {
  const match = description?.match(MODEL_NUMBER_PATTERN);
  return match ? vehicleModelTypeByModelNumber[match[1]] : undefined;
};

export const getVehicleModelType = (modelCode?: string, description?: string): VehicleModelType | undefined =>
  (modelCode ? vehicleModelTypeByModelCode[modelCode] : undefined) ?? getVehicleModelTypeByDescription(description);
